var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1909_11766)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_11766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.0208 62.4705C46.6718 65.717 43.0151 65.2044 39.4952 63.6666C35.7703 62.0946 32.3529 62.0262 28.4229 63.6666C23.5018 65.7854 20.9046 65.1702 17.9657 62.4705C1.2888 45.281 3.74932 19.1038 22.6817 18.1469C27.2951 18.3861 30.5075 20.6758 33.2072 20.8808C37.2398 20.0607 41.1014 17.7027 45.4073 18.0102C50.5676 18.4203 54.4634 20.4708 57.0265 24.1615C46.3642 30.5521 48.8931 44.5975 58.6668 48.5275C56.7189 53.6536 54.19 58.7455 49.9866 62.5047L50.0208 62.4705ZM32.8655 17.9419C32.3529 10.3211 38.5384 4.0331 45.6465 3.41797C46.6376 12.2348 37.6498 18.7962 32.8655 17.9419Z",
    fill: "#F4F4F4"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_11766",
    x: -73.165,
    y: -76.582,
    width: 211.832,
    height: 221.521,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 40
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0470588 0 0 0 0 0.0784314 0 0 0 0 0.192157 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_11766"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_11766",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1909_11766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 68,
    height: 68,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApple);
export default __webpack_public_path__ + "static/media/icon-apple.ea5b0375bf8608b4488d2cdd045178f5.svg";
export { ForwardRef as ReactComponent };